/**
 * @generated SignedSource<<75c927a8c2daacbfb18e27d67485e891>>
 * @relayHash 449b252c30e0e1ea61274ed95f3aaf56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477

import type { ConcreteRequest } from 'relay-runtime';
export type ContentConverterQuery$variables = {
  content: string;
  contentId: string;
  from: string;
  spaceKeyContext?: string | null | undefined;
  to: string;
};
export type ContentConverterQuery$data = {
  readonly contentConverter: {
    readonly value: string | null | undefined;
  } | null | undefined;
};
export type ContentConverterQuery = {
  response: ContentConverterQuery$data;
  variables: ContentConverterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "spaceKeyContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "content",
        "variableName": "content"
      },
      {
        "kind": "Variable",
        "name": "contentIdContext",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "spaceKeyContext",
        "variableName": "spaceKeyContext"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "ConfluenceBody",
    "kind": "LinkedField",
    "name": "contentConverter",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentConverterQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentConverterQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "449b252c30e0e1ea61274ed95f3aaf56",
    "id": "bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477",
    "metadata": {},
    "name": "ContentConverterQuery",
    "operationKind": "query",
    "text": "query ContentConverterQuery($content:String!,$contentId:ID!,$from:String!,$to:String!,$spaceKeyContext:String=\"\"){contentConverter(from:$from,to:$to,content:$content,contentIdContext:$contentId,spaceKeyContext:$spaceKeyContext){value}}"
  }
};
})();

(node as any).hash = "6980f8893393c2f02dae03f9d79f696a";

export default node;
